import { useMemo } from 'react';
import { useBasket } from './useBasket';
import { Product, ProductSearchResult } from '../types/product.types';
import { ShoppingDataLayerProduct } from '@makro-shopping/use-product-card-logic/dist/types/product.type';
import { BasketLineItem, PreviewBasketItemV5 } from '../types/basket.types';
import { findBasketItemWithPreviewItems } from '../utils/basket.util';

type CurrentBasketItemResult = {
  basketItem: BasketLineItem | PreviewBasketItemV5 | undefined;
  productCount: number;
};

export const useCurrentBasketItem = (
  product: Product | ProductSearchResult | ShoppingDataLayerProduct,
): CurrentBasketItemResult => {
  const { previewBasketItems } = useBasket();

  const basketItem: BasketLineItem | PreviewBasketItemV5 | undefined = useMemo(
    () => findBasketItemWithPreviewItems(product, previewBasketItems),
    [previewBasketItems, product],
  );

  return {
    basketItem: basketItem,
    productCount: basketItem?.quantity || 0,
  };
};